<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Katy Jordan is a multi-award-winning filmmaker who hails from Stirling while currently living in Glasgow. Since a young age, Katy has dreamed of being a writer and actress and, for the last ten years, has been actively pursuing both endeavours.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?01299cf2